<template>
  <section id="services">
    <v-sheet class="stats" color="secondary">
      <div class="py-12"></div>

      <v-container class="text-center">
        <!--      <h2 class="display-2 font-weight-bold text&#45;&#45;text mb-3">{{ $t('menuServices') }}</h2>-->

        <v-responsive class="mx-auto mb-12" width="56">


        </v-responsive>

        <v-row>
          <v-col v-for="({ icon, title, text }, i) in members" :key="i" cols="12" md="4">
            <v-card class="py-12 px-4" color="white lighten-3" flat>
              <v-theme-provider dark>
                <div>
                  <v-avatar class="icon" color="primary" size="88">
                    <v-icon large v-text="icon"></v-icon>
                  </v-avatar>
                </div>
              </v-theme-provider>

              <v-card-title class="justify-center font-weight-black text-center text--text text-uppercase"
                            v-html="$t(title)"></v-card-title>

              <div class="font-weight-light serviceText" v-text="$t(text)"></div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </v-sheet>
  </section>
</template>

<script>
export default {
  name: "Services",
  data: () => {
    return {
      members: [
        {
          icon: "mdi-account-group-outline",
          title: 'serviceTitle1',
          text: 'serviceText1'
        },
        {
          icon: "mdi-flag-checkered",
          title: 'serviceTitle2',
          text: 'serviceText2'
        },
        {
          icon: "mdi-update",
          title: 'serviceTitle3',
          text: 'serviceText3'
        }
      ]
    };
  }
};
</script>

<style scoped>
.icon {
  background-color: primary;
}

.serviceText {
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: .009375em;

}
</style>